export class LogSourceLocationCloudWatchLogs {
    'prefix';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocationCloudWatchLogs.attributeTypeMap;
    }
    constructor() {
    }
}
